import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import Link from '../Link';
import LogoOLX from '../LogoOLX';
import Text from '../Text';
import { VisuallyHidden } from '../VisuallyHidden';
import StaticUserProfile from './StaticUserProfile';
import IconButton from '../Header/components/IconButton';
import { sendClickEvent } from '../Header/utils';
import * as Styles from './styles';
import { ArrowLeft } from '@olxbr/ds-icons';
/**
 * Componente FocusHeader do Design System OLX
 */
export const FocusHeader = _ref => {
  let {
    fixed,
    title,
    inverted,
    userProfile,
    logoWithoutLink,
    hideLogo,
    goBack,
    teamKey
  } = _ref;
  const focusHeaderClassNames = [fixed ? 'fixed' : '', inverted ? 'inverted' : ''].filter(Boolean).join(' ');
  return React.createElement(React.Fragment, null, React.createElement(Styles.FocusHeaderWrapper, {
    "data-ds-component": "DS-FocusHeader",
    className: focusHeaderClassNames
  }, React.createElement(Styles.FocusHeaderContainer, null, !!goBack && React.createElement(IconButton, Object.assign({
    className: "header-go-back-button",
    onClick: () => {
      if (typeof goBack === 'function') {
        goBack();
      }
      sendClickEvent('back');
    },
    as: typeof goBack === 'string' ? 'a' : 'button'
  }, typeof goBack === 'string' && {
    href: goBack
  }), React.createElement(ArrowLeft, {
    "aria-hidden": "true"
  }), React.createElement(VisuallyHidden, null, "Voltar")), !hideLogo && (logoWithoutLink ? React.createElement(Styles.LogoContainer, {
    "aria-hidden": "true",
    className: goBack && title ? 'go-back' : ''
  }, React.createElement(LogoOLX, {
    variation: inverted ? 'white-o' : 'default'
  })) : React.createElement(Link, {
    href: "https://olx.com.br",
    onClick: () => sendClickEvent('logo'),
    className: "ds-primary-link ".concat(goBack && title ? 'go-back' : '')
  }, React.createElement(VisuallyHidden, null, "P\u00E1gina inicial"), React.createElement(Styles.LogoContainer, {
    "aria-hidden": "true"
  }, React.createElement(LogoOLX, {
    variation: inverted ? 'white-o' : 'default'
  })))), !!title && React.createElement(Text.BodyLarge, {
    tag: "h1",
    weight: "semibold"
  }, title), userProfile && !!teamKey && React.createElement(StaticUserProfile, {
    teamKey: teamKey
  }))));
};
FocusHeader.displayName = 'FocusHeader';